import { Stack } from '@mui/material';
import { Virtuoso } from 'react-virtuoso';
import { NoResults } from '../../shared/NoResults';
import { DocumentationCardItem } from '../../salesforce-documentation-card/types';
import { OCCUPIED_SPACE_SINGLE_OBJECT_VIEW_CANVAS } from '../../helpers';
import { useCardListHandleDeepLink } from './useCardListHandleDeepLink';
import { useIsCanvasUnited } from '../../../../hooks/useIsCanvasUnited';
import { CardListItem } from './CardListItem';
import { SalesforceItem } from '../../../parser/ConfigurationItemTypes';

interface CardListProps {
  list: SalesforceItem[];
  containerRef?: any;
  activeMetadataId?: string;
  handleSetConfigurationItem: (props: DocumentationCardItem) => void;
  withDetailedContentForRelatedObjects?: boolean;
  withApiNameOnHover?: boolean;
}

export const CardsList = ({
  list,
  containerRef,
  activeMetadataId,
  handleSetConfigurationItem,
  withDetailedContentForRelatedObjects: withDetailedContent,
  withApiNameOnHover,
}: CardListProps) => {
  const isCanvasUnited = useIsCanvasUnited();
  useCardListHandleDeepLink({ list, handleSetConfigurationItem });

  if (!list.length) {
    return (
      <Stack pl={2}>
        <NoResults />
      </Stack>
    );
  }

  return (
    <Virtuoso
      ref={containerRef}
      style={{
        height: `calc(100vh - ${
          isCanvasUnited ? OCCUPIED_SPACE_SINGLE_OBJECT_VIEW_CANVAS : '250px'
        })`,
      }}
      data={list}
      itemContent={(index, item) => (
        <CardListItem
          item={item}
          activeMetadataId={activeMetadataId}
          handleSetConfigurationItem={handleSetConfigurationItem}
          withDetailedContentForRelatedObjects={withDetailedContent}
          withApiNameOnHover={withApiNameOnHover}
        />
      )}
    />
  );
};
